module.exports = __webpack_public_path__ + "static/media/ic_traveler.2d0e3651.svg";